export default __webpack_public_path__ + "static/media/ic_tritangle_orange.faaad51c.svg";